"use client";

import { useContext, useEffect } from "react";
import {
  PageContentContext,
  type PageContentItem,
} from "../contexts/PageContentContext";

/**
 * Register a content item with the agent awareness system.
 * Handles registration on mount, deregistration on unmount,
 * and re-registration when the item changes.
 *
 * Uses `prefix` as the registration key so that duplicate mounts
 * of the same card (e.g. carousel + grid in CardOverviewGrid)
 * deduplicate in the content map instead of doubling.
 *
 * @param prefix - Unique key for this content item (e.g., "hubcard-maxMortgage")
 * @param item - Content item to register, or null/undefined to skip
 */
export const usePageContent = (
  prefix: string,
  item: PageContentItem | null | undefined,
) => {
  const { registerContent, deregisterContent } = useContext(PageContentContext);

  useEffect(() => {
    if (!item) return;
    registerContent(prefix, item);
    return () => deregisterContent(prefix);
  }, [prefix, item, registerContent, deregisterContent]);
};
